import app from 'app-instance';
import $ from 'jquery';
import ContentModal from '../../modal/js/content-modal';
import addItemMessage from '../html/add-item-message.hbs';
import addItemErrorMessage from '../html/add-item-error-message.hbs';

class BasketManager {
    constructor() {
        this.modal = new ContentModal('');
        this.getItemPriceUrl = '/api/product/calculateprice';
    }

    proceedSuccessAddToCart(result, options = {}) {
        if (result.Result) {
            app.emitEvent('basket', [result.ShoppingCart]);
            this.renderSuccessAddMessage(result, options);
        } else {
            console.error(result.Error);
            this.renderCartErrorMessage(result.Error);
        }
    }

    // this mean that request return 500
    proceedCartOperationError(error) {
        console.error(error);
        this.renderCartErrorMessage('The request can not be processed');
    }

    renderSuccessAddMessage(result, options) {
        const content = addItemMessage({
            basketDescription: `${result.ShoppingCart.TotalCount} item` + (result.ShoppingCart.TotalCount !== 1 ? 's' : ''),
            isEvent: result.IsEvent,
            eventLink: result.EventLink
        });

        if (!options.isModalUnclosable) {
            this.modal.enableClosing();
        } else {
            this.modal.disableClosing();
        }

        this.modal.setContent(content);
        this.modal.open();
    }

    renderCartErrorMessage(error) {
        const content = addItemErrorMessage({ message: error });
        this.modal.setContent(content);
        this.modal.open();
    }

    prepareItemOptions(options) {
        return options.reduce((result, option) => {
            switch (option.element.type) {
                case 'radio':
                    if (option.element.checked) {
                        result.push({ Id: option.id });
                    }
                    break;
                case 'text':
                case 'textarea':
                    result.push({ Id: option.id, Text: option.element.value });
                    break;
                case 'select-one':
                    if (option.element.value) {
                        result.push({ Id: option.element.value });
                    }

                    break;
                default:
            }
            return result;
        }, []);
    }

    doItemPriceRequest(body) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: 'post',
                url: this.getItemPriceUrl,
                data: body
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }
}

const basketManager = new BasketManager();
export default basketManager;



// WEBPACK FOOTER //
// ./app/components/shop/js/basket-manager.js